import { WORD_LENGTH } from '../../constants/settings'
import { WORD_COUNT } from '../../constants/countSpecific'
import { Cell } from './Cell'
import { unicodeSplit, isValidWord } from '../../lib/words'

type Props = {
  guess: string
  className: string
}

export const CurrentRow = ({ guess, className }: Props) => {
  const splitGuess = unicodeSplit(guess)
  const emptyCells = Array.from(
    Array(WORD_LENGTH * WORD_COUNT - splitGuess.length)
  )
  const classes = `flex justify-center mb-1 ${className}`
  const validWord = Array(WORD_COUNT)
  for (var word = 0; word < WORD_COUNT; word++) {
    if (guess.length > (word + 1) * WORD_LENGTH - 1) {
      validWord[word] = isValidWord(
        guess.substring(word * WORD_LENGTH, (word + 1) * WORD_LENGTH)
      )
      //console.debug('setting validWord[' + word + '] to ' + validWord[word])
    } else {
      validWord[word] = true
    }
  }

  return (
    <div className={classes}>
      {splitGuess.map((letter, i) => (
        <Cell
          key={i}
          value={letter}
          position={i}
          isValid={validWord[Math.floor(i / WORD_LENGTH)]}
        />
      ))}
      {emptyCells.map((_, i) => (
        <Cell key={i} position={splitGuess.length + i} />
      ))}
    </div>
  )
}
